<template>
    <div>
        <div v-for="(child, index) in dependents" :key="index">
            <hr class="mt-4 mb-4"/>

            <b-row>
                <b-col cols="6">
                    <h4 class="text-uppercase">Dependent #{{index+1}}</h4>
                </b-col>
                <b-col cols="6" class="text-right">
                    <b-button @click="removeChild(index)">Remove</b-button>
                </b-col>
            </b-row>
            <hr class="mt-0 mb-4"/>

            <b-row>
                <b-col md="5">
                    <b-form-group label="First Name:" label-for="firstName">
                        <b-form-input
                                type="text"
                                v-model="child.firstName">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Middle Initial:" label-for="middleName">
                        <b-form-input
                                type="text"
                                v-model="child.middleName"
                                max-length="1">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="5">
                    <b-form-group label="Last Name:" label-for="lastName">
                        <b-form-input
                                type="text"
                                v-model="child.lastName">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6">
                    <b-form-group label="Date of Birth:" label-for="dob">
                        <b-form-input
                                type="date"
                                v-model="child.dob"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Gender:" label-for="gender">
                        <b-form-select
                                id="gender"
                                type="text"
                                v-model="child.gender"
                                :options="genderOptions">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Relationship:" label-for="relationship">
                        <b-form-radio-group :options="dependentOptions" v-model="child.type"></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Other Coverage:" label-for="coverage">
                        <b-form-radio-group :options="otherCoverageOptions" v-model="child.cov"></b-form-radio-group>
                        <b-form-input
                                id="other_carrier"
                                type="text"
                                placeholder="Enter the carrier's name"
                                v-model="child.otherCarrier"
                                v-show="child.cov === 'Y'" class="mt-3">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>

        <hr class="mt-4 mb-4"/>

        <b-row>
            <b-col cols="12">
                <b-button @click="addChild()">Add Dependent</b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'Dependents',
        props: ['dependents'], // array,
        data: function() {
            return {
                otherCoverageOptions: [
                    {value: 'Y', text: 'Yes'},
                    {value: 'N', text: 'No Other Coverage'}
                ],
                genderOptions: [
                    {value: '', text: 'Please Select'},
                    {value: 'F', text: 'Female'},
                    {value: 'M', text: 'Male'}
                ],
                dependentOptions: [
                    {value: 'spouse', text: 'Spouse'},
                    {value: 'child', text: 'Child'}
                ]
            }
        },
        methods: {
            addChild: function () {
                this.dependents.push({})
            },
            removeChild: function (index) {
                this.dependents.splice(index, 1)
            }
        }
    }
</script>
<style>

</style>
